import { render, staticRenderFns } from "./userDetails.pug?vue&type=template&id=e32f766a&lang=pug&"
import script from "./userDetails.ts?vue&type=script&lang=ts&"
export * from "./userDetails.ts?vue&type=script&lang=ts&"
import style0 from "./userDetails.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports